import translations from './indium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/indium'

export const indium: Metal = {
  id: 28,
  slug: 'indium',
  name: t.name,
  symbol: 'In',
  // The sheet's pins are processing facilities, not mines: indium has no dedicated ore
  // deposits, it is recovered where zinc is smelted. Named by place rather than by
  // operator, as the sheet does — Ulsan rather than LS-Nikko, Kosaka rather than Dowa.
  mines: [
    {
      name: 'Zhuzhou (China, indium processing)',
      region: 'Zhuzhou',
      coordinates: [113.13, 27.83],
    },
    {
      name: 'Ulsan (South Korea, indium processing)',
      region: 'Ulsan',
      coordinates: [129.31, 35.54],
    },
    {
      name: 'Trail (Canada, indium processing)',
      region: 'Trail',
      coordinates: [-117.7, 49.1],
    },
    {
      name: 'Kosaka (Japan, indium processing)',
      region: 'Kosaka',
      coordinates: [140.76, 40.31],
    },
  ],
  countries: [
    { name: 'China', percent: 70.4 },
    { name: 'South Korea', percent: 16.7 },
    { name: 'Japan', percent: 5.6 },
    { name: 'Canada', percent: 3.7 },
    { name: 'France', percent: 1.9 },
  ],
  important: true,
  // Recovered as a by-product of zinc smelting — the sheet's one related metal, and the
  // source of every environmental and human impact its copy describes.
  related: ['zinc'],
  video: {
    name: 'indium',
    poster: '/mine-my-phone/images/posters/indium.jpg',
  },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['screen'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 2, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
          credit: 'Simone Francescangeli',
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
          credit: 'Simone Francescangeli',
        },
      ],
      secondBento: [
        {
          src: `${dir}/04.jpg`,
          orientation: 'horizontal',
          credit: 'Simone Francescangeli',
        },
        {
          src: `${dir}/05.jpg`,
          orientation: 'vertical',
          credit: 'CFOTO / Getty',
        },
        {
          src: `${dir}/06.jpg`,
          orientation: 'vertical',
          credit: 'Bloomberg / Getty',
        },
      ],
    },
  },
}
